'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TimeSubscriber = exports.TimeSubscriberPropTypes = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _store = require('../store');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TIMEUPDATE = 'timeupdate';
var SOFTTIMEUPDATE = 'softtimeupdate';
var MS_TO_S = 1000;

var _videoSeekingCollection = {};

var TimeSubscriberPropTypes = exports.TimeSubscriberPropTypes = {
  currentTimeMs: _propTypes2.default.number,
  emitSoftTimeUpdate: _propTypes2.default.func,
  setSeeking: _propTypes2.default.func
};

/**
 * Component that has access to currentTimeMs for an associated player.
 * Extend this component to gain access. When extending this you will need to
 * spread the original `state` into the new state in your constructor.
 * In addition make sure to utilise the constructor to provide options.
 */

var TimeSubscriber = exports.TimeSubscriber = function (_Component) {
  _inherits(TimeSubscriber, _Component);

  function TimeSubscriber(props, context) {
    _classCallCheck(this, TimeSubscriber);

    var _this = _possibleConstructorReturn(this, (TimeSubscriber.__proto__ || Object.getPrototypeOf(TimeSubscriber)).call(this, props, context));

    _initialiseProps.call(_this);

    _this._initialized = false;
    var playerId = context.playerId;
    var player = (0, _store.getPlayerInstance)(playerId);
    var currentTimeMs = 0;
    var playingIndex = 0;

    if (player) {
      currentTimeMs = player.currentTime * MS_TO_S;
      playingIndex = player.playingIndex;
    }

    _this.state = {
      playingIndex: playingIndex,
      currentTimeMs: currentTimeMs,
      listenToSoftTimeUpdates: props.listenToSoftTimeUpdates,
      playerId: playerId,
      player: null
    };
    return _this;
  }

  _createClass(TimeSubscriber, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      (0, _store.queueTimeComponent)(this.state.playerId, this.setup);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.state.player) {
        this.state.player.removeEventListener(TIMEUPDATE, this.timeUpdate);
      } else if (!this._initialized) {
        (0, _store.dequeueTimeComponent)(this.state.playerId, this.setup);
      }
      if (this.state.listenToSoftTimeUpdates) {
        window.removeEventListener(SOFTTIMEUPDATE, this.softTimeUpdate);
      }
    }

    /**
     * Used when a Component wants to communicate a timeupdate that shouldn't affect the video.
     * An example scenario would be when scrubbing on the video, you would call this function with the new time,
     * which would then propagate that time to all other `TimeSubscribers`.
     *
     * @param {Number} currentTimeMs - The new time to be propagated to other TimeSubscribers
     */

  }, {
    key: 'render',
    value: function render() {
      var singleChild = Array.isArray(this.props.children) ? this.props.children[0] : this.props.children;
      return (0, _react.cloneElement)(singleChild, {
        playingIndex: this.state.playingIndex,
        currentTimeMs: this.state.currentTimeMs,
        emitSoftTimeUpdate: this.emitSoftTimeUpdate,
        setSeeking: this.setSeeking
      });
    }
  }]);

  return TimeSubscriber;
}(_react.Component);

TimeSubscriber.propTypes = {
  listenToSoftTimeUpdates: _propTypes2.default.bool,
  children: _propTypes2.default.node.isRequired
};
TimeSubscriber.contextTypes = {
  playerId: _propTypes2.default.string
};
TimeSubscriber.defaultProps = {
  listenToSoftTimeUpdates: true
};

var _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.timeUpdate = function () {
    if (!_this2.state.player) {
      throw Error('Video has not been initialized');
    }

    if (!_videoSeekingCollection[_this2.state.playerId]) {
      _this2.setState({
        playingIndex: _this2.state.player.playingIndex,
        currentTimeMs: _this2.state.player.currentTime * MS_TO_S
      });
    }
  };

  this.softTimeUpdate = function (event) {
    if (!_this2.state.player) {
      throw Error('Video has not been initialized');
    }
    var detail = event.detail;

    if (_this2.state.playerId === detail.playerId && detail.currentTimeMs >= 0) {
      // Soft time updates shouldn't change the playingIndex, so
      // this should be fine.
      _this2.setState({ currentTimeMs: detail.currentTimeMs });
    }
  };

  this.setSeeking = function (s) {
    _videoSeekingCollection[_this2.state.playerId] = s;
  };

  this.setup = function () {
    var playerId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this2.state.playerId;
    var player = arguments[1];

    if (!_videoSeekingCollection[playerId]) {
      _videoSeekingCollection[playerId] = false;
    }
    player.addEventListener(TIMEUPDATE, _this2.timeUpdate);
    _this2.setState({
      player: player,
      playerId: playerId,
      currentTimeMs: (player.currentTime || 0) * MS_TO_S
    });

    if (_this2.state.listenToSoftTimeUpdates) {
      window.addEventListener(SOFTTIMEUPDATE, _this2.softTimeUpdate);
    }
    _this2._initialized = true;
  };

  this.emitSoftTimeUpdate = function (currentTimeMs) {
    if (!_this2.state.player) {
      throw Error('Video has not been initialized');
    }
    window.dispatchEvent(new CustomEvent(SOFTTIMEUPDATE, {
      detail: {
        currentTimeMs: currentTimeMs,
        playerId: _this2.state.playerId
      }
    }));
  };
};